import { render, staticRenderFns } from "./profile-header.vue?vue&type=template&id=fb6172f2&scoped=true&lang=pug&"
import script from "./profile-header.vue?vue&type=script&lang=js&"
export * from "./profile-header.vue?vue&type=script&lang=js&"
import style0 from "./profile-header.vue?vue&type=style&index=0&id=fb6172f2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6172f2",
  null
  
)

export default component.exports